'use strict';

var index = require('../complex/index.cjs');
var filter = require('../complex/filter.cjs');
var defaults = require('../maps/defaults.cjs');

function getAnimatableNone(key, value) {
    let defaultValueType = defaults.getDefaultValueType(key);
    if (defaultValueType !== filter.filter)
        defaultValueType = index.complex;
    // If value is not recognised as animatable, ie "none", create an animatable version origin based on the target
    return defaultValueType.getAnimatableNone
        ? defaultValueType.getAnimatableNone(value)
        : undefined;
}

exports.getAnimatableNone = getAnimatableNone;
//# sourceMappingURL=animatable-none.cjs.map
